import type { DoOrDumpReportNarrativeSnapshot } from "@/lib/do-or-dump-report-narrative-snapshot";
import { staticDoOrDumpNarrativeFromSnapshot } from "@/lib/do-or-dump-static-narrative";
import { invokeEdgeFunction } from "@/lib/edge-functions";
import type { DoOrDumpReportNarrative } from "@/types/do-or-dump-report-narrative";

export async function fetchDoOrDumpReportNarrative(
  snapshot: DoOrDumpReportNarrativeSnapshot,
  signal?: AbortSignal,
): Promise<DoOrDumpReportNarrative> {
  try {
    const data = await invokeEdgeFunction<{ narrative?: DoOrDumpReportNarrative }>(
      "openai-report-narrative",
      { snapshot },
      signal,
    );
    if (data?.narrative) return data.narrative;
  } catch (e) {
    if (e instanceof Error && e.name === "AbortError") throw e;
    console.warn("[report-narrative] edge unavailable, using static copy", e);
  }
  return staticDoOrDumpNarrativeFromSnapshot(snapshot);
}
